<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="epi">
<div class="epigraph">
<div class="senseline">
<p class="epslf"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>And we know, when Moses was told,</p>
<p class="epsl">in the way he was told,</p>
<p class="epsl">“Take off your shoes!” He grew pale from that simple</p>
<p class="epslf">reminder of fire in the dusty earth.</p>
<p class="epsl">He never recovered</p>
<p class="epsl">his complicated way of loving again</p>
<p class="epslf">and was free to love in the same way</p>
<p class="epsl">he felt the fire licking at his heels loved him.</p>
</div>
<p class="ept">—David Whyte, “Fire in the Earth”</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// rbgfeder0007.vue?177b1876